module.exports = __webpack_public_path__ + "static/media/daima ji_page-0001.cd5f8c16.jpg";